export default "__VITE_ASSET__CwzZKHT3__"